import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";

export function SortFavoriteNodesByLastModifiedTime(
    favoriteNodes: IWorkflowNode[] = []
) {
    return [...favoriteNodes].sort((left, right) => {
        const leftTime = GetLastModifiedTime(left);
        const rightTime = GetLastModifiedTime(right);

        if (leftTime === null && rightTime !== null) {
            return 1;
        }

        if (leftTime !== null && rightTime === null) {
            return -1;
        }

        if (leftTime !== null && rightTime !== null && leftTime !== rightTime) {
            return rightTime - leftTime;
        }

        return right.id - left.id;
    });
}

function GetLastModifiedTime(node: IWorkflowNode) {
    const time = new Date(node.lastmodifiedtime).getTime();
    return Number.isFinite(time) ? time : null;
}
